import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Trophy, Star } from "lucide-react";
import api from "../../lib/api";
import { useTheme } from "../../context/ThemeContext";
import { ThemedShell } from "../../components/child/ThemedShell";
import { AVATARS } from "../../lib/constants";
import { Button } from "../../components/ui/button";

export default function Leaderboard() {
  const navigate = useNavigate();
  const { theme, terms } = useTheme();
  const [board, setBoard] = useState([]);

  useEffect(() => { api.get("/child/leaderboard").then(({ data }) => setBoard(data.leaderboard)); }, []);

  const medal = (rank) => rank === 1 ? "🥇" : rank === 2 ? "🥈" : rank === 3 ? "🥉" : null;
  const muted = { color: "var(--t-muted)" };

  return (
    <ThemedShell>
      <header className="sticky top-0 z-30 border-b backdrop-blur-md" style={{ background: `color-mix(in srgb, var(--t-surface) 75%, transparent)`, borderColor: "var(--t-border)" }}>
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Button variant="ghost" onClick={() => navigate("/leerling")} className="rounded-full font-bold" style={{ color: "var(--t-text)" }} data-testid="back-dashboard-btn"><ArrowLeft className="w-5 h-5 mr-1" /> Terug</Button>
          <span className="flex items-center gap-2"><span className="text-2xl">{theme.mascot}</span><span className="font-heading font-extrabold themed-heading">{theme.name}</span></span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 pt-10 pb-16">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-3xl flex items-center justify-center mx-auto mb-4" style={{ background: "var(--t-surface2)" }}><Trophy className="w-9 h-9" strokeWidth={2.5} style={{ color: "var(--t-accent)" }} /></div>
          <h1 className="font-heading text-3xl font-black themed-heading">{terms.leaderboard}</h1>
          <p className="font-semibold mt-1" style={muted}>{terms.leaderboardSub}</p>
        </div>

        <div className="space-y-2.5">
          {board.map((p, i) => (
            <motion.div key={i} initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }}
              className="flex items-center gap-4 p-4 rounded-2xl border-2" data-testid={`rank-${p.rank}`}
              style={p.is_me ? { background: "var(--t-surface2)", borderColor: "var(--t-accent)" } : { background: "var(--t-surface)", borderColor: "var(--t-border)" }}>
              <div className="w-10 text-center font-heading font-black text-xl">{medal(p.rank) || `#${p.rank}`}</div>
              <div className="w-9 h-9 rounded-full flex items-center justify-center text-lg" style={{ background: "var(--t-surface2)" }}>{AVATARS[p.avatar] || "🦊"}</div>
              <div className="flex-1">
                <p className="font-heading font-bold">{p.name} {p.is_me && <span className="text-xs font-bold" style={{ color: "var(--t-accent)" }}>(jij)</span>}</p>
                <p className="text-sm font-semibold flex items-center gap-1" style={muted}><Star className="w-3.5 h-3.5" style={{ color: "var(--t-accent)", fill: "var(--t-accent)" }} /> {terms.level} {p.level}</p>
              </div>
              <div className="font-heading font-extrabold">{p.xp} {terms.xp}</div>
            </motion.div>
          ))}
          {board.length === 0 && <p className="text-center font-semibold py-10" style={muted}>Nog geen spelers.</p>}
        </div>
      </main>
    </ThemedShell>
  );
}
